import React, { useEffect, useRef } from 'react';
import './PlatformSection.css';

const PlatformSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);

  // Intersection Observer para animação de scroll
  useEffect(() => {
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <section ref={sectionRef} id="como-funciona">
      <div className="container">
        <h2 className="section-title">Como Funciona</h2>
        <p className="">Simplificamos a complexidade — conecte, automatize e acelere tudo num só lugar.
          Com as nossas integrações inteligentes, as suas operações tornam-se mais simples, rápidas e escaláveis.</p>
        <div className="grid cols-2" style={{ marginTop: '22px' }}>
          <div className="card">
            <h3>Integração com Inteligência Artificial</h3>
            <p>Deixe a IA trabalhar por si.
              Como se estivesse a conversar com o seu próprio secretário digital através de linguagem natural (NLP), a IA entende, executa e conecta todas as suas integrações — de forma fluida, inteligente e automatizada.</p>
          </div>
          <div className="card">
            <h3>Conexão com ERP e Bases de Dados</h3>
            <p>Todos os seus sistemas, perfeitamente ligados. <br />
              Sincronize dados em tempo real e transforme informação em decisões inteligentes.</p>
          </div>
          <div className="card">
            <h3> Simulações Automatizadas</h3>
            <p>Chegue ao preço certo em segundos. <br />
              Realize simulações rápidas e precisas, otimizando processos sem complicações.</p>
          </div>
          <div className="card">
            <h3>Documentação Inteligente</h3>
            <p>Fale diretamente com a sua documentação.
              Faça perguntas sobre coberturas, exclusões ou condições específicas e obtenha respostas imediatas — como se consultasse um especialista de cada seguradora.
              Aceda à informação que precisa, no momento certo, com total clareza e segurança.</p>
          </div>
          <div className="card">
            <h3>Comunicação Direta e Personalizada</h3>
            <p>Comunique de forma simples e eficaz. <br />
              Envie mensagens personalizadas e mantenha relações consistentes com clientes e parceiros.</p>
          </div>
          <div className="card">
            <h3>Campanhas de Marketing</h3>
            <p>Ative as suas campanhas de marketing em segundos. <br />
              Através dos canais de comunicação da sua escolha, configure, segmente e implemente campanhas com total controlo e automação.</p>
          </div>
        </div>
        <h3 className="text-center" style={{ marginTop: '22px', textAlign: 'center' }}> Tudo Integrado. Tudo Fluido.</h3>
        <p className="section-sub">Uma solução que cresce consigo.
          Automatize o que importa e concentre-se no que realmente gera valor.</p>
      </div>
    </section>
  );
};

export default PlatformSection;